export default function Spotify() {
    return (
        <div className="spotify-container">
           <iframe style={{borderRadius: '12px',marginTop:"20px"}} title="s" src="https://open.spotify.com/embed/playlist/2xVdsOSQdTFgPOovp9XBP2?utm_source=generator&theme=0" width="100%" height={200} frameBorder={0} allowFullScreen allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" />

        </div>
    )

}